import { getRcmApi } from './rcmApi';

function getClient() {
  return getRcmApi();
}

function debugLog(method: string, url: string, data: unknown) {
  if (import.meta.env.DEV) {
    // Helps verify wire payloads while wiring RCM pages (list/detail adapters).
    console.debug(`[rcm-api] ${method} ${url}`, data);
  }
}

export async function get<T>(url: string, params?: Record<string, unknown>): Promise<T> {
  const res = await getClient().get<T>(url, { params });
  debugLog('GET', url, res.data);
  return res.data;
}

export async function post<T>(
  url: string,
  data?: unknown,
  params?: Record<string, unknown>
): Promise<T> {
  const res = await getClient().post<T>(url, data, params ? { params } : undefined);
  debugLog('POST', url, res.data);
  return res.data;
}

export async function patch<T>(
  url: string,
  data?: unknown,
  params?: Record<string, unknown>
): Promise<T> {
  const res = await getClient().patch<T>(url, data, params ? { params } : undefined);
  debugLog('PATCH', url, res.data);
  return res.data;
}

export async function put<T>(
  url: string,
  data?: unknown,
  params?: Record<string, unknown>
): Promise<T> {
  const res = await getClient().put<T>(url, data, params ? { params } : undefined);
  debugLog('PUT', url, res.data);
  return res.data;
}

export async function del<T>(url: string, params?: Record<string, unknown>): Promise<T> {
  const res = await getClient().delete<T>(url, { params });
  debugLog('DELETE', url, res.data);
  return res.data;
}

export async function postFormData<T>(
  url: string,
  formData: FormData,
  headers?: Record<string, string>
): Promise<T> {
  const res = await getClient().post<T>(url, formData, {
    headers: headers
      ? { ...headers, 'Content-Type': 'multipart/form-data' }
      : { 'Content-Type': 'multipart/form-data' },
  });
  debugLog('POST(form)', url, res.data);
  return res.data;
}
